import React, { FC } from 'react'
import Icon from '../icon/Icon';
import { IconType } from 'lib/helpers/constants/iconTypes';


interface RemoveFilterProps {
    DeleteData: () => void;
    condition: any
}


const RemoveFIlter: FC<RemoveFilterProps> = ({ DeleteData, condition }) => {

    if (!condition) {
        return null;
    }

    return (
        <div className="absolute right-1 top-[calc(50%_-_14px)] bg-white cursor-pointer px-2 py-1 z-50" onClick={DeleteData}>
            <Icon iconType={IconType.CLOSE_X_SM_ICON} />
        </div>
    )
}

export default RemoveFIlter